(function () {
  'use strict';
  if (window.LehaCardPricing) return;
  var groups = new Map();
  var active = true;
  var queued = false;
  var scopes = new Set();
  var contextKeys = ['preview_theme_id', 'preview_key', '_fd', '_sc', 'view'];
  function contextUrl(href) {
    var current = new URL(window.location.href);
    var url = new URL(href, current);
    if (url.origin === current.origin) contextKeys.forEach(function (key) {
      if (current.searchParams.has(key) && !url.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    });
    return url;
  }
  function formUrl(form) {
    var url = contextUrl(form.action);
    var current = new URL(window.location.href);
    current.searchParams.forEach(function (value, key) {
      if (!key.startsWith('filter.') && !['sort_by', 'page', 'section_id', 'sections', '_leha_refresh'].includes(key) && !url.searchParams.has(key)) url.searchParams.append(key, value);
    });
    new FormData(form).forEach(function (value, key) { if (value !== '') url.searchParams.append(key, value); });
    url.searchParams.delete('page');
    return url;
  }
  function eligible(group) {
    return !group.disposed && group.root.isConnected && active && !document.hidden && navigator.onLine !== false;
  }
  function paint(group, status) {
    var now = performance.now();
    var pending = false;
    group.cards.forEach(function (card) {
      var state = group.states.get(card);
      var valid = state && state.status === 'resolved' && state.country_code === card.dataset.lehaCountry &&
        String(state.variant_id) === card.dataset.lehaCardVariant && now < Math.max(group.leaseUntil || 0, group.displayUntil.get(card) || 0);
      var price = card.querySelector('[data-leha-card-price]');
      var html = group.html.get(card);
      window.LehaCommercialPricing.presentPrice(price, valid ? 'resolved' : status === 'checking' ? 'checking' : 'unavailable', html,
        {unavailable: card.dataset.lehaUnavailable, retry: card.dataset.lehaRetry}, true);
      if (!valid && status === 'checking') pending = true;
      if (card.hasAttribute('data-leha-offer-only')) card.hidden = !valid || card.dataset.lehaDismissed === 'true' || state.source !== 'seasonal_offer' || !state.offer_reference || !html.trim();
    });
    var announcement = pending ? group.cards[0].dataset.lehaChecking : status === 'retrying' ? group.cards[0].dataset.lehaUnavailable : '';
    if (announcement && group.announcement.textContent !== announcement) group.announcement.textContent = announcement;
  }
  function invalidate(group, status, preserve) {
    group.sequence += 1;
    clearTimeout(group.timer);
    clearTimeout(group.deadline);
    if (group.request) group.request.abort();
    group.request = null;
    if (!preserve) { group.leaseUntil = 0; group.displayUntil.clear(); }
    group.root.dataset.lehaCardRefreshStatus = status;
    paint(group, status);
  }
  function owns(group, sequence) {
    return group.sequence === sequence && eligible(group) && group.cards.every(function (card) { return group.countries.get(card) === card.dataset.lehaCountry; });
  }
  function dispose(group) {
    invalidate(group, 'unavailable');
    group.disposed = true;
    group.announcement.remove();
    groups.delete(group.root);
  }
  function requestUrl(group) {
    var recommendations = group.root.querySelector('product-recommendations[data-url]');
    var url = recommendations ? contextUrl(recommendations.dataset.url) : new URL(window.location.href);
    url.hash = '';
    url.searchParams.delete('sections');
    url.searchParams.set('section_id', group.id);
    url.searchParams.set('_leha_refresh', String(Date.now()) + '-' + group.sequence);
    return url;
  }
  async function refresh(group) {
    if (!eligible(group)) return;
    if (group.cards.some(function (card) { return group.countries.get(card) !== card.dataset.lehaCountry; })) {
      invalidate(group, 'checking');
      group.cards.forEach(function (card) { group.countries.set(card, card.dataset.lehaCountry); });
    }
    if (group.request) return;
    invalidate(group, 'checking', true);
    var sequence = group.sequence;
    var controller = new AbortController();
    var started = performance.now();
    group.request = controller;
    var displayExpiry = Math.min.apply(null, Array.from(group.displayUntil.values()).filter(function (until) { return until > started; })) - started;
    if (Number.isFinite(displayExpiry) && displayExpiry > 0) group.timer = setTimeout(function () { paint(group, 'checking'); }, displayExpiry);
    function recover(code, delay) {
      if (!owns(group, sequence)) return;
      group.root.dataset.lehaCardRefreshDiagnostic = code;
      invalidate(group, 'retrying');
      if (code === 'pricing_boundary' && group.boundaryRetries++ < 1) group.timer = setTimeout(function () { refresh(group); }, delay || 1000);
    }
    group.deadline = setTimeout(function () { recover('pricing_timeout'); }, 10000);
    try {
      var url = requestUrl(group);
      group.root.dataset.lehaCardRequestUrl = url.href;
      var response = await window.LehaCommercialPricing.sectionRequest(url.href, group.cards[0].dataset.lehaCountry, controller.signal);
      if (!owns(group, sequence)) return;
      var data = group.root.dataset;
      data.lehaCardResponseStatus = String(response.status);
      data.lehaCardResponseUrl = response.url || '';
      data.lehaCardResponseDate = response.headers.get('Date') || '';
      data.lehaCardResponseAge = response.headers.get('Age') || '';
      data.lehaCardResponseType = response.headers.get('Content-Type') || '';
      data.lehaCardResponseRedirected = String(Boolean(response.redirected));
      if (!response.ok || !/text\/html|application\/json/i.test(data.lehaCardResponseType)) throw new Error('pricing_response');
      var html = await response.text();
      if (!owns(group, sequence)) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var candidates = Array.from(parsed.querySelectorAll('[data-leha-card]')).filter(function (card) { return card.dataset.lehaSectionId === group.id; });
      if (!candidates.length) throw new Error('pricing_section_missing');
      var elapsed = performance.now() - started;
      var canonical = new Map();
      var candidateMap = new Map();
      candidates.forEach(function (candidate) {
        var key = candidate.dataset.lehaCardKey;
        if (!candidateMap.has(key)) candidateMap.set(key, []);
        candidateMap.get(key).push(candidate);
      });
      var returnedEvidence = [];
      data.lehaCardResponseEvidence = '[]';
      var updates = group.cards.map(function (card) {
        var key = card.dataset.lehaCardKey;
        var variant = card.dataset.lehaCardVariant;
        var country = card.dataset.lehaCountry;
        if (card.dataset.lehaSectionId !== group.id || key.split(':').pop() !== variant) throw new Error('pricing_card_identity');
        var evidence = canonical.get(key);
        if (evidence) {
          if (evidence.variant !== variant || evidence.country !== country) throw new Error('pricing_card_conflict');
          return { card: card, state: evidence.state, html: evidence.html, lease: evidence.lease };
        }
        var matches = candidateMap.get(key) || [];
        if (!matches.length) throw new Error('pricing_card_missing');
        matches.forEach(function (fresh) {
          if (fresh.dataset.lehaCardVariant !== variant) throw new Error('pricing_card_identity');
          if (fresh.dataset.lehaCountry !== country) throw new Error('country_changed');
          var stateElement = fresh.querySelector('[data-leha-card-state]');
          var priceElement = fresh.querySelector('[data-leha-card-price]');
          if (!stateElement || !priceElement) throw new Error('pricing_card_missing');
          var state = JSON.parse(stateElement.textContent);
          returnedEvidence.push({ key: key, variant: state && state.variant_id, country: state && state.country_code, resolved_at: state && state.resolved_at, freshness_delta_ms: Date.parse(data.lehaCardResponseDate) - Date.parse(state && state.resolved_at) });
          data.lehaCardResponseEvidence = JSON.stringify(returnedEvidence);
          var lease = window.LehaCommercialPricing.responseLease(state, variant, country, response.headers, elapsed);
          // Resolver v1 is a flat record. JSON member order is not pricing evidence.
          var signature = JSON.stringify(Object.keys(state).sort().map(function (name) { return [name, state[name]]; }));
          if (evidence && (evidence.signature !== signature || evidence.html !== priceElement.innerHTML)) throw new Error('pricing_card_conflict');
          evidence = { variant: variant, country: country, state: state, html: priceElement.innerHTML, lease: lease, signature: signature };
        });
        canonical.set(key, evidence);
        return { card: card, state: evidence.state, html: evidence.html, lease: evidence.lease };
      });
      if (!owns(group, sequence)) return;
      clearTimeout(group.deadline);
      group.request = null;
      updates.forEach(function (update) {
        group.states.set(update.card, update.state);
        group.html.set(update.card, update.html);
        var element = update.card.querySelector('[data-leha-card-state]');
        var text = JSON.stringify(update.state);
        group.payloads.set(element, text);
        if (element.textContent !== text) element.textContent = text;
      });
      group.root.querySelectorAll('[data-leha-package-contents]').forEach(function (contents) {
        var next = Array.from(parsed.querySelectorAll('[data-leha-package-contents]')).find(function (node) {
          return node.dataset.lehaPackageKey === contents.dataset.lehaPackageKey;
        });
        if (next) {
          if (contents.innerHTML !== next.innerHTML) contents.innerHTML = next.innerHTML;
          contents.removeAttribute('aria-busy');
        }
      });
      data.lehaCardRefreshStatus = 'validated';
      data.lehaCardRefreshDiagnostic = '';
      group.cycles += 1;
      data.lehaCardValidatedRefreshes = String(group.cycles);
      if (group.announcement.textContent !== group.cards[0].dataset.lehaUpdated) group.announcement.textContent = group.cards[0].dataset.lehaUpdated;
      var lease = Math.min.apply(null, updates.map(function (update) { return update.lease; }));
      group.leaseUntil = performance.now() + lease;
      group.displayUntil.clear();
      group.boundaryRetries = 0;
      paint(group, 'validated');
      clearTimeout(group.timer);
      group.timer = setTimeout(function () { refresh(group); }, lease);
    } catch (error) {
      recover(error.message || 'pricing_response', error.message === 'pricing_boundary' ? 1000 : 10000);
    }
  }
  function scan(scope) {
    scope = scope || document;
    var links = Array.from(scope.querySelectorAll('[data-leha-context-link]'));
    if (scope.matches && scope.matches('[data-leha-context-link]')) links.push(scope);
    links.forEach(function (link) { var href = contextUrl(link.href).href; if (link.href !== href) link.href = href; });
    var roots = new Set();
    if (scope.closest) { var enclosing = scope.closest('.shopify-section'); if (enclosing) roots.add(enclosing); }
    scope.querySelectorAll('[data-leha-card][data-leha-section-id]').forEach(function (card) { var root = card.closest('.shopify-section'); if (root) roots.add(root); });
    groups.forEach(function (group, root) {
      if (!root.isConnected) dispose(group);
    });
    roots.forEach(function (root) {
      var cards = Array.from(root.querySelectorAll('[data-leha-card][data-leha-section-id]'));
      var previous = groups.get(root);
      if (previous && (cards.length !== previous.cards.length || cards.some(function (card, index) { return card !== previous.cards[index]; }))) dispose(previous);
      if (groups.has(root) || !cards.length) return;
      var announcement = document.createElement('span');
      announcement.className = 'leha-presentation-sr-only';
      announcement.setAttribute('aria-live', 'polite');
      announcement.setAttribute('aria-atomic', 'true');
      root.appendChild(announcement);
      var group = { root: root, id: cards[0].dataset.lehaSectionId, cards: cards, announcement: announcement, sequence: 0, cycles: 0, disposed: false,
        states: new Map(), html: new Map(), displayUntil: new Map(), countries: new Map(), payloads: new WeakMap(), leaseUntil: 0, boundaryRetries: 0 };
      cards.forEach(function (card) {
        group.countries.set(card, card.dataset.lehaCountry);
        group.html.set(card, card.querySelector('[data-leha-card-price]')?.innerHTML || '');
        try {
          var state = JSON.parse(card.querySelector('[data-leha-card-state]').textContent);
          group.payloads.set(card.querySelector('[data-leha-card-state]'), card.querySelector('[data-leha-card-state]').textContent);
          group.states.set(card, state);
          group.displayUntil.set(card, performance.now() + window.LehaCommercialPricing.bootstrapLease(state, card.dataset.lehaCardVariant, card.dataset.lehaCountry));
        } catch (error) {}
      });
      groups.set(root, group);
      refresh(group);
    });
  }
  function scheduleScan(scope) {
    scopes.add(scope || document);
    if (!queued) {
      queued = true;
      queueMicrotask(function () { queued = false; var pending = Array.from(scopes); scopes.clear(); pending.forEach(scan); });
    }
  }
  function suspend() {
    active = false;
    groups.forEach(function (group) { invalidate(group, 'unavailable'); });
  }
  function resume() {
    active = true;
    groups.forEach(function (group) { if (performance.now() >= group.leaseUntil || group.cards.some(function (card) { return group.countries.get(card) !== card.dataset.lehaCountry; })) refresh(group); });
  }
  function init() {
    if (!window.LehaCommercialPricing) return;
    scan();
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') {
          var card = record.target.closest('[data-leha-card]');
          var group = card && groups.get(card.closest('.shopify-section'));
          if (group) refresh(group);
          return;
        }
        var script = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (script && script.matches('[data-leha-card-state]')) {
          var owner = groups.get(script.closest('.shopify-section'));
          if (owner && owner.payloads.get(script) !== script.textContent) {
            owner.payloads.set(script, script.textContent); invalidate(owner, 'checking'); refresh(owner);
          }
          return;
        }
        var nodes = Array.from(record.addedNodes).concat(Array.from(record.removedNodes));
        if (nodes.some(function (node) { return node.nodeType === 1 && (node.matches('[data-leha-card], [data-leha-context-link], .shopify-section') || node.querySelector('[data-leha-card], [data-leha-context-link]')); })) scheduleScan(record.target);
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-leha-country'] });
    document.addEventListener('shopify:section:load', function (event) { scheduleScan(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { groups.forEach(function (group) { if (event.target === group.root || event.target.contains(group.root)) dispose(group); }); });
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-leha-price-retry]');
      if (!button) return;
      var group = groups.get(button.closest('.shopify-section'));
      if (!group) return;
      event.preventDefault(); group.boundaryRetries = 0; refresh(group);
    });
    // The existing cart handler sets value only after Shopify confirms its update.
    // Re-read native bundle contents; never multiply or add component quantities.
    new MutationObserver(function (records) {
      var affected = new Set();
      records.forEach(function (record) {
        if (!record.target.matches('.cart-page .quantity__input')) return;
        groups.forEach(function (group) {
          if (group.root.contains(record.target) && group.root.querySelector('[data-leha-package-contents]')) affected.add(group);
        });
      });
      affected.forEach(function (group) {
        group.root.querySelectorAll('[data-leha-package-contents]').forEach(function (contents) {
          contents.textContent = group.cards[0].dataset.lehaRetrying;
          contents.setAttribute('aria-busy', 'true');
        });
        refresh(group);
      });
    }).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['value'] });
    document.addEventListener('submit', function (event) {
      if (!event.target.matches('[data-leha-collection-form]')) return;
      event.preventDefault();
      window.location.assign(formUrl(event.target).href);
    });
    document.addEventListener('visibilitychange', function () { if (document.hidden) suspend(); else resume(); });
    window.addEventListener('focus', resume);
    window.addEventListener('offline', suspend);
    window.addEventListener('online', resume);
    window.addEventListener('pagehide', suspend);
    window.addEventListener('pageshow', function (event) { if (event.persisted) suspend(); resume(); });
  }
  window.LehaCardPricing = { contextUrl: contextUrl, formUrl: formUrl };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}());
